<script>
export default {
  name: "ReferralNotesTab",

  props: {
    referral: Array,
    encounters: Array,
  },

  methods: {

      printMedicalFile() {
          window.print();
      },
  },
}
</script>
<template>
  <div class="w-full flex flex-col p-1">
    <div v-for="encounter in encounters" :key="encounter.encounterId">
        <div 
          class="w-full flex flex-wrap"
          v-if="referral.length &&
              referral.filter((ref) => ref.encounterID == encounter.encounterId)
                .length">
          <div class="w-full flex flex-wrap p-2 bg-gray-300">
            <div class="flex-1">
              <h5 class="font-medium text-sm">Referral Note</h5>
            </div>
            <div class="flex-1">
                <router-link
                  v-if="
                        ($root.formatLowercase(encounter.userName) ==
                        $root.formatLowercase($root.username)) ||
                        $root.checkAuth('AdminEditMedicalFile') ? true : false
                      " 
                  :to="{
                    name: `med-f.visit.index`,
                    params: {
                      patientID: $route.params.patientID,
                      visitNo: $route.params.visitNo,
                    },
                    query: {
                      encounterID: encounter.encounterId,
                      from: $route.query.from,
                    },
                  }" 
                  class="btn-sm btn-warning text-xs text-white rounded hide--print">Edit Encounter</router-link>
            </div>
          </div>
          <div class="w-full p-1">
            <div
              class="my-px"
              v-for="ref in referral.filter(ref => ref.encounterID == encounter.encounterId)"
              :key="ref.id"
            >
              <span v-html="ref.referralNotes"></span>
              <div class="w-full p-2 bg-gray-200">
                <h5 class="font-medium text-xs capitalize">Done By: {{ ref.userName }}</h5>
              </div>
            </div>
          </div>
          <div class="w-full p-1 text-right">
              <button 
                  @click.prevent="printMedicalFile"
                  class="btn-sm btn-primary text-xs">
                      <i class="fa fa-print"></i> Print</button>
          </div>
        </div>
    </div>
  </div>
</template>
